import { NgModule } from '@angular/core';
import { TimefromnowPipe } from './timefromnow-pipe';

@NgModule({
  declarations: [TimefromnowPipe],
  imports: [],
  providers: [TimefromnowPipe],
  exports: [TimefromnowPipe]
})
export class TimefromnowPipeModule { }
